<template>
  <div>
    <custom-modal modal-width="25rem" body-padding="0 24px 20px" @close="closeModal">
      <template #header>
        {{ deleteDialog.title }}
      </template>

      <template #body>
        {{ deleteDialog.description }}
      </template>

      <template #footer>
        <custom-button
          :button-class="{ 'btn btn-cancel': true, 'btn-cancel-active': focusedButton === 'cancel' }"
          @click="closeModal()"
        >
          {{ $t("actions.cancel") }}
        </custom-button>
        <custom-button
          :button-class="{ 'btn btn-confirm': true, 'btn-confirm-active': focusedButton === 'confirm' }"
          @click="confirmAction"
          >{{ $t("actions.confirm") }}
        </custom-button>
      </template>
    </custom-modal>
  </div>
</template>

<script>
import hotkeys from "hotkeys-js";
import { HotkeyScopes } from "../../../utils/constants";
import CustomButton from "../../commons/CustomButton.vue";
import CustomModal from "../../commons/CustomModal.vue";

export default {
  components: {
    CustomButton,
    CustomModal,
  },
  data() {
    return {
      previousHotkeyScope: null,
      focusedButton: "confirm", // Default focus on confirm button
    };
  },
  computed: {
    deleteDialog() {
      return this.$store.state.panel.deleteDialog;
    },
  },
  mounted() {
    this.bindScope();
  },
  beforeUnmount() {
    hotkeys.unbind("enter, tab, escape, right, left,shift+tab", HotkeyScopes.DeleteConfirmDialog);
  },
  methods: {
    resetScope() {
      if (hotkeys.getScope() === HotkeyScopes.DeleteConfirmDialog) {
        this.$store.dispatch("setScope", this.previousHotkeyScope ?? HotkeyScopes.All);
        hotkeys.unbind("enter, tab, escape, right, left,shift+tab", HotkeyScopes.DeleteConfirmDialog);
      }
    },
    bindScope() {
      if (hotkeys.getScope() !== HotkeyScopes.DeleteConfirmDialog) {
        this.previousHotkeyScope = hotkeys.getScope();
        this.$store.dispatch("setScope", HotkeyScopes.DeleteConfirmDialog);
      }
      hotkeys("enter, tab, escape, right, left,shift+tab", HotkeyScopes.DeleteConfirmDialog, (e, handler) => {
        e.preventDefault();

        switch (handler.key) {
          case "escape":
            this.closeModal();
            break;
          case "right":
          case "left":
          case "tab":
          case "shift+tab":
            this.toggleFocus();
            break;
          case "enter":
            // if (this.showDialog) {
            this.triggerFocusedButtonAction();
            // }
            break;
        }
      });
    },
    closeModal() {
      this.focusedButton = "confirm";
      this.$store.dispatch("panel/setDeleteDialog", {
        show: false,
        ids: null,
        title: null,
        description: null,
        itemType: null,
        action: null,
      });
      this.resetScope();
    },
    confirmAction() {
      if (this.deleteDialog.action) {
        this.deleteDialog.action(); // Call the action provided in the dialog state
      }
      this.closeModal();
    },
    toggleFocus() {
      this.focusedButton = this.focusedButton === "cancel" ? "confirm" : "cancel";
    },
    triggerFocusedButtonAction() {
      if (this.focusedButton === "cancel") {
        this.closeModal();
      } else {
        this.confirmAction();
      }
    },
  },
};
</script>
